if (!customElements.get('variant-picker')) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product');
      this.productForm = this.section.querySelector('.js-product-form-main');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();
      this.variant = this.getSelectedVariant();
      this.selectedOptions = this.getSelectedOptions();
      this.preSelection =
        !this.variant && this.selectedOptions.includes(null);

      this.addEventListener(
        'change',
        this.handleVariantChange.bind(this)
      );

      setTimeout(() => {
        this.handleVariantChange({
          type: 'init',
          target: this.querySelector('input.js-option:checked') ||
                  this.querySelector('input.js-option')
        });
      });
    }

    handleVariantChange(evt) {
      this.filterLinkedOptions();
      this.selectedOptions = this.getSelectedOptions();
      this.variant = this.getSelectedVariant();
      this.preSelection =
        !this.variant && this.selectedOptions.includes(null);

      if (this.variant) {
        this.updateMedia();
        this.updateUrl(evt);
        this.updateVariantInput();
      }

      this.updateAddToCartButton();
      this.updateAvailability();
      this.updatePrice();
      this.updateWeight();
      this.updateBarcode();
      this.updateBackorderText();
      this.updatePickupAvailability();
      this.updateSku();
      this.updateProductTitle();
      this.updateMetafieldVisibility();

      if (evt.target?.closest('.option-selector')) {
        VariantPicker.updateLabelText(evt);
      }

      if (!this.preSelection) {
        this.dispatchEvent(new CustomEvent('on:variant:change', {
          bubbles: true,
          detail: {
            form: this.productForm,
            variant: this.variant,
            product: this.data.product
          }
        }));
      }
    }

    updateMetafieldVisibility(){document.querySelectorAll('[data-variant-metafield]').forEach((elem)=>{elem.classList.toggle('hidden',elem.dataset.variantMetafield!==this.variant?.id.toString())})}

    updateAddToCartButton(){this.productForm=this.section.querySelector('.js-product-form-main');if(!this.productForm)return;this.addBtn=this.addBtn||this.productForm.querySelector('[name="add"]');const variantAvailable=this.variant&&this.variant.available;this.addBtn.disabled=!variantAvailable||this.preSelection;if(this.preSelection){this.addBtn.textContent=theme.strings.noSelectedVariant}else{const unavailableStr=this.variant?theme.strings.noStock:theme.strings.noVariant;this.addBtn.textContent=variantAvailable?this.addBtn.dataset.addToCartText:unavailableStr}}

    static updateOptionAvailability(optionEl,exists,available){const el=optionEl;const unavailableText=exists?theme.strings.noStock:theme.strings.noVariant;el.classList.toggle('is-unavailable',!available);el.classList.toggle('is-nonexistent',!exists);if(optionEl.classList.contains('custom-select__option')){const em=el.querySelector('em');if(em){em.hidden=available}
    if(!available){if(em){em.textContent=unavailableText}else{el.innerHTML=`${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`}}}else if(!available){el.nextElementSibling.title=unavailableText}else{el.nextElementSibling.removeAttribute('title')}}

    updateAvailability(){if(this.dataset.showAvailability==='false')return;const{availabilityMethod}=this.dataset;let currVariant=this.variant;if(!this.variant){currVariant={options:this.selectedOptions}}
    if(availabilityMethod==='selection'){this.querySelectorAll('.js-option').forEach((optionEl)=>{VariantPicker.updateOptionAvailability(optionEl,!1,!1)});this.optionSelectors.forEach((selector,selectorIndex)=>{this.data.product.variants.forEach((variant)=>{let matchCount=0;variant.options.forEach((option,optionIndex)=>{if(option===currVariant.options[optionIndex]&&optionIndex!==selectorIndex){matchCount+=1}});if(matchCount===currVariant.options.length-1){const options=selector.querySelectorAll('.js-option');const optionEl=Array.from(options).find((opt)=>{if(selector.dataset.selectorType==='dropdown'){return opt.dataset.value===variant.options[selectorIndex]}
    return opt.value===variant.options[selectorIndex]});if(optionEl){VariantPicker.updateOptionAvailability(optionEl,!0,variant.available)}}})})}else{this.optionSelectors.forEach((selector,selectorIndex)=>{const options=selector.querySelectorAll('.js-option:not([data-value=""])');options.forEach((option)=>{const optionValue=selector.dataset.selectorType==='dropdown'?option.dataset.value:option.value;let variantsExist=!1;let variantsAvailable=!1;this.data.product.variants.forEach((v)=>{let matches=0;for(let i=0;i<selectorIndex;i+=1){if(v.options[i]===this.selectedOptions[i]||this.selectedOptions[i]===null){matches+=1}}
    if(v.options[selectorIndex]===optionValue&&matches===selectorIndex){variantsExist=!0;if(v.available){variantsAvailable=!0}}});VariantPicker.updateOptionAvailability(option,variantsExist,variantsAvailable)})})}}

    updateBackorderText(){this.backorder=this.backorder||this.section.querySelector('.backorder');if(!this.backorder)return;let hideBackorder=!0;if(this.variant&&this.variant.available){const{inventory}=this.data.formatted[this.variant.id];if(this.variant.inventory_management&&inventory==='none'){const backorderProdEl=this.backorder.querySelector('.backorder__product');const prodTitleEl=this.section.querySelector('.product-title');const variantTitle=this.variant.title.includes('Default')?'':` - ${this.variant.title}`;backorderProdEl.textContent=`${prodTitleEl.textContent}${variantTitle}`;hideBackorder=!1}}
    this.backorder.hidden=hideBackorder}

    static updateLabelText(evt){const selector=evt.target.closest('.option-selector');if(selector.dataset.selectorType==='dropdown')return;const colorText=selector.querySelector('.js-color-text');if(!colorText)return;colorText.textContent=evt.target.nextElementSibling.querySelector('.js-value').textContent}

    updateMedia(){if(!this.variant.featured_media)return;if(this.section.matches('quick-add-drawer')){this.section.updateMedia(this.variant.featured_media.id)}else{this.mediaGallery=this.mediaGallery||this.section.querySelector('media-gallery');if(!this.mediaGallery)return;const variantMedia=this.mediaGallery.querySelector(`[data-media-id="${this.variant.featured_media.id}"]`);this.mediaGallery.setActiveMedia(variantMedia,!0,!0)}}

    updatePickupAvailability(){this.pickUpAvailability=this.pickUpAvailability||this.section.querySelector('pickup-availability');if(!this.pickUpAvailability)return;if(this.variant&&this.variant.available){this.pickUpAvailability.getAvailability(this.variant.id)}else{this.pickUpAvailability.removeAttribute('available');this.pickUpAvailability.innerHTML=''}}

    updatePrice(){this.price=this.price||this.section.querySelector('.product-info__price > .price');if(!this.price)return;let{variant}=this;if(this.preSelection){variant=this.data.product.variants[0];for(let i=1;i<this.data.product.variants.length;i+=1){if(this.data.product.variants[i].price<variant.price)variant=this.data.product.variants[i]}}
    if(this.variant){const priceCurrentEl=this.price.querySelector('.price__current');const priceWasEl=this.price.querySelector('.price__was');const unitPriceEl=this.price.querySelector('.unit-price');if(variant.compare_at_price>variant.price){priceCurrentEl.querySelector('.js-label').textContent=theme.strings.salePrice;priceCurrentEl.querySelector('.js-value').innerHTML=this.data.formatted[variant.id].price;if(priceWasEl){priceWasEl.querySelector('.js-label').textContent=theme.strings.regularPrice;priceWasEl.querySelector('.js-value').innerHTML=this.data.formatted[variant.id].compareAtPrice||''}}else{priceCurrentEl.querySelector('.js-label').textContent=theme.strings.regularPrice;priceCurrentEl.querySelector('.js-value').innerHTML=this.data.formatted[variant.id].price;if(priceWasEl){priceWasEl.querySelector('.js-label').textContent='';priceWasEl.querySelector('.js-value').innerHTML=''}}
    if(this.variant.unit_price_measurement){const valueEl=this.price.querySelector('.unit-price__price');const unitEl=this.price.querySelector('.unit-price__unit');const value=this.variant.unit_price_measurement.reference_value;const unit=this.variant.unit_price_measurement.reference_unit;valueEl.innerHTML=this.data.formatted[this.variant.id].unitPrice;unitEl.textContent=value===1?unit:`${value} ${unit}`}
    unitPriceEl.hidden=!this.variant.unit_price_measurement;this.price.classList.toggle('price--on-sale',this.variant.compare_at_price>this.variant.price);this.price.classList.toggle('price--sold-out',!this.variant.available&&!this.preSelection)}
    this.price.querySelector('.price__default').hidden=!this.variant&&!this.preSelection;this.price.querySelector('.price__no-variant').hidden=this.variant||this.preSelection;const from=this.price.querySelector('.price__from');if(from){from.hidden=!this.preSelection}}

    updateWeight(){this.weights=this.weights||this.section.querySelectorAll('.product-info__weight');if(this.weights.length===0)return;const weightAvailable=this.variant&&this.variant.weight>0;this.weights.forEach((weight)=>{weight.textContent=weightAvailable?this.data.formatted[this.variant.id].weight:'';weight.hidden=!weightAvailable})}

    updateBarcode(){this.barcodes=this.barcodes||this.section.querySelectorAll('.product-info__barcode-value');if(this.barcodes.length===0)return;const barcodeAvailable=this.variant&&this.variant.barcode;this.barcodes.forEach((barcode)=>{barcode.textContent=barcodeAvailable?this.variant.barcode:'';barcode.parentNode.hidden=!barcodeAvailable})}

    updateSku(){this.sku=this.sku||this.section.querySelector('.product-sku__value');if(!this.sku)return;const skuAvailable=this.variant&&this.variant.sku;this.sku.textContent=skuAvailable?this.variant.sku:'';this.sku.parentNode.hidden=!skuAvailable}

    updateUrl(evt){if(!evt||evt.type!=='change'||this.dataset.updateUrl==='false')return;window.history.replaceState({},'',`${this.dataset.url}?variant=${this.variant.id}`)}

    updateVariantInput(){this.forms=this.forms||this.section.querySelectorAll('.js-product-form-main, .js-instalments-form');this.forms.forEach((form)=>{const input=form.querySelector('input[name="id"]');input.value=this.variant.id;input.dispatchEvent(new Event('change',{bubbles:!0}))})}

    filterLinkedOptions() {
      let selected = this.getSelectedOptions();

      this.optionSelectors.forEach((selector, index) => {
        if (index === 0 || selected.slice(0, index).includes(null)) return;
        if (selector.dataset.selectorType === 'dropdown') return;

        const matching = this.data.product.variants.filter((variant) =>
          selected.slice(0, index).every((value, i) =>
            variant.options[i] === value
          )
        );

        const inputs = Array.from(
          selector.querySelectorAll('input.js-option')
        );

        inputs.forEach((input) => {
          const exists = matching.some((variant) =>
            variant.options[index] === input.value
          );

          input.disabled = !exists;
          const label = input.nextElementSibling;
          if (label) label.style.display = exists ? '' : 'none';
        });

        const current = inputs.find((input) => input.checked);

        if (current && current.disabled) {
          current.checked = false;

          const replacement =
            inputs.find((input) => matching.some((variant) =>
              variant.available && variant.options[index] === input.value
            )) ||
            inputs.find((input) => !input.disabled);

          if (replacement) replacement.checked = true;
        }

        selected = this.getSelectedOptions();
      });
    }

    updateProductTitle() {
      const title = this.section.querySelector(
        '.product-info__title .product-title'
      );
      if (!title) return;

      const baseTitle = String(
        this.data.product.title || title.textContent
      ).trim();

      if (!/hemdchen.*tragetaschen.*hdpe/i.test(baseTitle)) return;

      const rows = [
        ['20+10*30', 7],
        ['25+12*40', 8],
        ['25+12*45', 7],
        ['25+14*48', 9],
        ['25+12*45', 10],
        ['25+12*47', 12],
        ['25+12*45', 14],
        ['30+16*52', 12],
        ['30+14*50', 15],
        ['30+18*55', 12],
        ['35+16*55', 17],
        ['30+18*60', 15]
      ];

      const sizeIndex = this.data.product.options.findIndex(option => {
        const name = typeof option === 'string' ? option : option.name;
        return /^(size|größe|groesse|abmessungen)$/i.test(
          String(name).trim()
        );
      });

      let text = 'Hemdchen-Tragetaschen – HDPE';

      if (this.variant && sizeIndex >= 0) {
        const value = String(this.variant.options[sizeIndex])
          .replace(/\s+/g, '')
          .replace(/[×x]/gi, '*');

        const match = value.match(
          /^(\d+\+\d+\*\d+)[-–](\d+)(?:microns?|µm|μm)$/i
        );

        const row = match && rows.find(([size, thickness]) =>
          size === match[1] && thickness === Number(match[2])
        );

        if (row) {
          text +=
            ' – ' + row[0].replace('*', ' × ') +
            ' cm – ' + row[1] + ' µm – Transparent';
        }
      }

      title.querySelector('.js-selected-title-options')?.remove();

      const textNodes = Array.from(title.childNodes).filter(
        node => node.nodeType === 3
      );

      if (textNodes.length) {
        textNodes[0].textContent = text;
        textNodes.slice(1).forEach(node => {
          node.textContent = '';
        });
      } else {
        title.prepend(document.createTextNode(text));
      }
    }

    getSelectedOptions() {
      const selectedOptions = [];

      this.optionSelectors.forEach((selector) => {
        if (selector.dataset.selectorType === 'dropdown') {
          const selectedText = selector.querySelector(
            '.custom-select__btn'
          ).textContent.trim();

          selectedOptions.push(
            selectedText === this.dataset.placeholderText
              ? null
              : selectedText
          );
        } else {
          const selected = selector.querySelector('input:checked');
          selectedOptions.push(selected ? selected.value : null);
        }
      });

      return selectedOptions;
    }

    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();

      return this.data.product.variants.find((variant) =>
        variant.options.every((value, index) =>
          value === selectedOptions[index]
        )
      );
    }
  }

  customElements.define('variant-picker', VariantPicker);
}